import store from '@/store';

const guard = async(to, from, next) => {
  store.commit('SET_CSAT_DISPLAY', false);

  next();
};

export default guard;
